import { ChangeEvent, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { AUTRE, FRENCH_COLONIES_FILE_INDEX, STATUS } from '../enums/common'
import { ResidenceFiscale } from '../components/step5/Options'
import { computeAddressType, getOptionLabelByValue } from '../services/utils'
import { folderActions } from '../store/slices/Folder'
import { IStep5ResidenceFiscale } from '../interfaces/Step5'
import { useTriggerChangeHook } from './triggerChangeHook'
import { FRANCE, MONACO } from '../enums/Countries'
import { getItemSuffix } from '../utils/getItemSuffix'

const Step5ResidenceFiscaleHook = (props: IStep5ResidenceFiscale) => {
  const { state, form, folderData, address, item } = props
  const { watch } = form
  const { pays_residence_ficale_import } = folderData
  const fiscalAddressCountrySuffix = `fiscal_address_country${getItemSuffix(
    item
  )}`
  const taxCountryOtherSuffix = `tax_country_other${getItemSuffix(item)}`

  const pays_residence_ficale =
    folderData[`pays_residence_ficale${getItemSuffix(item)}`]
  const tax_country_other = folderData[taxCountryOtherSuffix]
  const fiscal_address_country = folderData[fiscalAddressCountrySuffix]
  const [domicileFiscaleType, setDomicileFiscaleType] = useState('')
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(
      folderActions.folderReceived({
        domicile_fiscale_type: domicileFiscaleType,
      })
    )
  }, [domicileFiscaleType])

  const watchFiscalAddressCountry: string = watch(
    fiscalAddressCountrySuffix,
    fiscal_address_country
  )
  const watchFiscalAddressCountryOther: string = watch(
    taxCountryOtherSuffix,
    tax_country_other
  )

  useTriggerChangeHook(fiscalAddressCountrySuffix)
  useTriggerChangeHook(taxCountryOtherSuffix)

  const fiscalAddressCountryAutre = watchFiscalAddressCountry === AUTRE
  const fiscalAddressCountryFrance = watchFiscalAddressCountry === FRANCE
  const updatePaysResidenceFicaleValue = (
    value: string,
    fiscalAddressCountrySuffixArg: string
  ) => {
    if (value === MONACO || value === FRANCE) {
      if (fiscalAddressCountrySuffixArg === 'fiscal_address_country_2') {
        setDomicileFiscaleType(computeAddressType(address?.country, value))
        dispatch(
          folderActions.folderReceived({
            pays_residence_ficale_2: value,
          })
        )
      } else {
        setDomicileFiscaleType(computeAddressType(address?.country, value))
        dispatch(folderActions.folderReceived({ pays_residence_ficale: value }))
      }
    }
    if (value === AUTRE) {
      if (fiscalAddressCountrySuffixArg === 'fiscal_address_country_2') {
        dispatch(
          folderActions.folderReceived({
            pays_residence_ficale_2: watchFiscalAddressCountryOther,
          })
        )
      } else {
        dispatch(
          folderActions.folderReceived({
            pays_residence_ficale: watchFiscalAddressCountryOther,
          })
        )
      }
    }
  }

  const handleFiscalAddressCountryChange = (
    event: ChangeEvent<HTMLSelectElement>,
    fiscalAddressCountrySuffixArg: string
  ) => {
    const { value } = event.target
    updatePaysResidenceFicaleValue(value, fiscalAddressCountrySuffixArg)

    if (!pays_residence_ficale_import) {
      dispatch(
        folderActions.folderReceived({
          pays_residence_ficale_import: pays_residence_ficale,
        })
      )
    }
  }

  const handleTaxCountryOtherChange = (
    value: string,
    taxCountryOtherSuffixArg?: string
  ) => {
    if (taxCountryOtherSuffixArg === 'tax_country_other_2') {
      setDomicileFiscaleType(computeAddressType(address?.country, value))
      dispatch(
        folderActions.folderReceived({
          pays_residence_ficale_2: value,
        })
      )
    } else {
      setDomicileFiscaleType(computeAddressType(address?.country, value))
      dispatch(
        folderActions.folderReceived({
          pays_residence_ficale: value,
        })
      )
    }
  }

  let showFiscalAddressCountrySelect = true
  let selectFiscalAddressCountryLabel = ''
  if (state[item ? FRENCH_COLONIES_FILE_INDEX : 0]) {
    const statusColonies = state[item ? FRENCH_COLONIES_FILE_INDEX : 0]?.status
    showFiscalAddressCountrySelect = statusColonies !== STATUS.validated

    if (!showFiscalAddressCountrySelect) {
      selectFiscalAddressCountryLabel = getOptionLabelByValue(
        ResidenceFiscale,
        watchFiscalAddressCountry
      )
    }
  }

  return {
    fiscalAddressCountryAutre,
    showFiscalAddressCountrySelect,
    selectFiscalAddressCountryLabel,
    pays_residence_ficale,
    handleFiscalAddressCountryChange,
    handleTaxCountryOtherChange,
    domicileFiscaleType,
    fiscalAddressCountryFrance,
  }
}

export default Step5ResidenceFiscaleHook
